var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"SearchChartItem"},[_c('div',{staticClass:"component-title"},[_vm._v("共检索到"),_c('span',[_vm._v(_vm._s(_vm.total))]),_vm._v("个相关图谱"),_c('EchartSankey')],1)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-a86fd2e4","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/index/EventSearch/SearchChartItem/SearchChartItem.vue
// module id = null
// module chunks = 